import React from 'react';
import {News} from './news';
import style from './style.scss';
import {BusinessNotification} from './notification';
import {Link} from 'react-router-dom';

class TheNews extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className="the-news">
        <section className="create-product-box box-wrap">
          <div className='wrap-create-product'>
            <p className="create-product-header">Hãy Bắt Đầu</p>
            <Link to="/my-business/post-product" className="post-product">ĐĂNG SẢN PHẨM</Link>
            <p>cho doanh nghiệp của bạn</p>
          </div>
          <div className="wrap-next-steps">
            <ul>
              Các bước tiếp theo
              <li><Link to='/cms/gioi-thieu-ve-san-tmdjt'>Đọc hướng dẫn về Sàn TMĐT</Link></li>
              <li><Link to='/cms/quy-che-hoat-djong'>Quy chế hoạt động Sàn TMĐT</Link></li>
              <li><Link to='/cms/dieu-khoan-and-dieu-kien-giao-dich'>Điều khoản và điều kiện giao dịch</Link></li>
            </ul>
          </div>
          {/* <div className="wrap-other-actions">
            <ul>
              Các hành động khác
              <li><Link to=''>Giới thiệu về PhuyenTrade.GOV.VN</Link></li>
              <li><Link to=''>Quy chế hoạt động Sàn TMĐT</Link></li>
              <li><Link to=''>Điều khoản và điều kiện giao dịch</Link></li>
            </ul>
          </div> */}

        </section>
        {/* <News/> */}
      </section>
    );
  }
}

export default TheNews;



// WEBPACK FOOTER //
// ./components/users/sub-view/the-news/TheNews.jsx